import { Field, FieldValue } from './field/field';
import { FieldObjectCst } from './field/field-object';
import {
	GROUPS_LEFT,
	GROUPS_LEFT_LEFT,
	GROUPS_LEFT_RIGHT,
	GROUPS_RIGHT,
	LayoutGroupContent,
	LayoutGroup,
	LayoutSection,
	LayoutSectionContent
} from './product-card-layout-builder';

function retrieveCharacteristicField(
	product: FieldObjectCst,
	characteristicName: string
) {
	const field = product.getField(characteristicName);
	if (!field) {
		return undefined;
	}
	if (field.type === 'objectCst') {
		throw new Error(
			`expected a leaf (or an array) at ${ characteristicName }, but found ${ typeof field }`
		);
	}
	return field;
}

function createSection(
	product: FieldObjectCst,
	sectionContent: LayoutSectionContent
) {
	const characteristicFields: Field<FieldValue>[] = [];
	for (const characteristic of sectionContent.characteristics) {
		const characteristicField = retrieveCharacteristicField(product, characteristic);
		if (characteristicField !== undefined) {
			characteristicFields.push(characteristicField);
		}
	}
	return characteristicFields.length > 0
		? new LayoutSection(
			sectionContent.title,
			characteristicFields
		)
		: undefined;
}

function createGroup(
	product: FieldObjectCst,
	groupContent: LayoutGroupContent
) {
	const sections: LayoutSection[] = [];
	for (const sectionContent of groupContent.sections) {
		const section = createSection(product, sectionContent);
		if (section !== undefined) {
			sections.push(section);
		}
	}
	return sections.length > 0
		? new LayoutGroup(groupContent.title, sections)
		: undefined;
}

function createGroups(
	product: FieldObjectCst,
	groupContents: LayoutGroupContent[]
) {
	const groups: LayoutGroup[] = [];
	for (const groupContent of groupContents) {
		const group = createGroup(product, groupContent);
		if (group !== undefined) {
			groups.push(group);
		}
	}
	return groups;
}

export function buildLayout(
	product: FieldObjectCst
) {
	return {
		groupsLeft: createGroups(product, GROUPS_LEFT),
		groupsLeftLeft: createGroups(product, GROUPS_LEFT_LEFT),
		groupsLeftRight: createGroups(product, GROUPS_LEFT_RIGHT),
		groupsRight: createGroups(product, GROUPS_RIGHT),
	};
}
